<template>
  <div class="box">
    <div class="photo">
      <a href="https://hw.sxbicsp.cn/static/video/index.html" target="_blank">
        <i class="el-icon-camera"></i>
        <span>拍照测试</span>
      </a>
    </div>

    <div class="box-title flex flex_align-items flex_justify-center">
      <img style="width: 80px;margin-right: 10px" src="~@/assets/logo.png" alt="">
      <span>BICSP在线学习系统</span>
    </div>

    <el-form :model="form" ref="form" :rules="rules">

      <el-form-item prop="loginName">
        <el-input v-model="form.loginName" placeholder="账号（手机号码）"></el-input>
      </el-form-item>

      <el-form-item prop="password">
        <el-input type="password" v-model="form.password" placeholder="密码"></el-input>
      </el-form-item>

    </el-form>

    <el-button @click="handleLogin('form')" type="primary" style="width: 100%">登录</el-button>

    <div class="layout-tip pointer flex flex_align-items flex_space-between">
      <span @click="handleToRegister">
        注册
      </span>
      <router-link to="/resets">
        忘记密码？
      </router-link>
    </div>

  </div>
</template>

<script>
export default {
  name: "login-from",
  data() {
    return {
      form: {
        loginName: '',
        password: ''
      },
      rules: {
        loginName: [
          { required: true, message: '请输入账号', trigger: ['blur', 'change'] },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: ['blur', 'change'] },
        ],
      },
    }
  },
  mounted() {
    let that = this
    document.onkeydown = function (e) {
      e = window.event || e
      //保证是在登录页面发出的enter事件
      if ((that.$route.path === '/') && (e.code === 'Enter' || e.code === 'enter')) {
        //调用登录函数
        that.handleLogin('form')
      }
    }
  },
  methods: {
    handleLogin(formName) {
      //  获取浏览器内核
      let isChrome = window.navigator.userAgent.indexOf("Chrome") !== -1;
      if(!isChrome) {
        const h = this.$createElement;
        this.$msgbox({
          title: '浏览器提示',
          message: h('p', null, [
            h('span', null, '检测到您使用的浏览器不是谷歌浏览器，请您切换谷歌浏览进行学习'),
          ]),
          showCancelButton: false,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '执行中...';
              setTimeout(() => {
                done();
                setTimeout(() => {
                  instance.confirmButtonLoading = false;
                }, 300);
              }, 1000);
            } else {
              done();
            }
          }
        })
        return false;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$post(this.$API.MEMBER_LOGIN, {
            ...this.form
          }).then( res => {
            if(res.code === 200) {
              this.$message({
                message: '登录成功',
                type: 'success'
              });
              this.$store.commit('SET_TOKEN', res.data.token)
              this.$store.commit('SET_USER', res.data.userinfo)

              if(!res.data.userInfo.idCard) {

                this.$confirm('系统检测到您还未绑定身份证信息，不能观看视频，请前去绑定身份证信息?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                }).then(() => {
                  setTimeout(() => {
                    this.$router.push('/homeUser/userInfo')
                  }, 1000)
                }).catch(() => {
                  this.$router.push('/home')
                });

              } else {

                setTimeout(() => {
                  this.$router.push('/home')
                }, 1000)

              }
            } else this.$message.error(res.msg);

          }).catch(err => {
            console.log(err)
          })
        } else {
          return false;
        }
      });
    },
    handleToRegister() {
      this.$emit('isShowRegister')
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  position: relative;
  transform: translateY(-50%);
  box-shadow: 2px 2px 8px rgb(0 0 0 / 5%);
  border-radius: 8px;
  padding: 40px 30px;
  box-sizing: border-box;
  width: 400px;

  &-title {
    margin-bottom: $spacing-row-lg;

    span {
      font-size: $font-size-lg;
      font-weight: 600;
    }
  }

  .layout-tip {
    font-size: $font-size-base;
    margin-top: 10px;

    a {
      color: $font-text-color-grey;
    }
    span {
      color: $font-text-color-grey;
    }
  }
}
.photo {
  cursor: pointer;
  position: absolute;
  top: -80px;
  right: 0;
  font-size: 26px;


  a {
    color: #2196f3;
    display: flex;
    align-items: center;
    span {
      padding-left: 10px;
      font-size: 20px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
